import { Input, Spinner } from '@/components/ui'
import { formatPhoneNumber, formatDate } from '@/utils/formatters'
import EmailLink from '@/components/EmailLink'
import Address from "@/components/Address"
import { UserCircleIcon } from '@heroicons/react/24/outline'

import { useContactContext } from '../ContactShow'

const SocieteItem = ({item = {}}) => (
  <div>
    <span className="uppercase">{item.nom_complet}</span>
      <a href={`/contacts/${item.id}`} className="btn btn-sm btn-circle btn-outline tooltip tooltip-right" data-tip="Voir la société">
        <UserCircleIcon className="w-4 h-4" />
      </a>
  </div>
)

export default () => {
  const { contact, loading } = useContactContext()
  return (
    <>
      <div>
        <Input.Display label="Civilité" value={contact.civilite} valueClassName="uppercase"/>
        <Input.Display label="Nom" value={contact.nom ? contact.nom.toUpperCase() : ''} valueClassName="uppercase" />
        <Input.Display label="Prénom" value={contact.prenom} valueClassName="uppercase" />
        <Input.Display label="Date de naissance" value={formatDate(contact.date_naissance)} />
        <Input.Display label="Lieu de naissance" value={contact.lieu_naissance} valueClassName="uppercase" />
        <Input.Display label="N° de pièce d'identité" value={contact.numero_piece_identite} valueClassName="uppercase" />
      </div>
      <div>
        <Input.Display label="Adresse" value={contact.ville} forceEmptyPlaceholder={true} className="flex mb-2" valueClassName="uppercase">
          <Address data={contact} />
        </Input.Display>
        <Input.Display label="Téléphone" value={formatPhoneNumber(contact.telephone)} />
        <Input.Display label="Email" value={contact.email} forceEmptyPlaceholder={true} >
          <EmailLink email={contact.email} />
        </Input.Display>
        <Input.Display label="Profession" value={contact.profession} valueClassName="uppercase" />
      </div>
            
      <div>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Les sociétés :</label>
          <div className="textarea textarea-bordered w-full">
            { loading && <Spinner color='gray-600'/> }
            {contact.societes?.map( (s, index) => <SocieteItem item={s} key={index} />) || ""}
          </div>
        </div>
      </div>
    </>
  )
}